module.exports = __webpack_public_path__ + "static/img/jry.66f19b6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jry.jpg
// module id = GNdU
// module chunks = 0